let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b3LV2")).then(() => parcelRequire('kK8ZL'));